import React from 'react';

export default function DetailedView() {
  return (
    <div className="px-0 pt-2">
      <p className="text-muted mb-0">
        Visão detalhada (placeholder).
      </p>
    </div>
  );
}
